import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Navbar from "./Navbar";
import Footer from "./Footer";
import FloatingWhatsApp from "./FloatingWhatsApp";
import useGoogleAnalytics from "../lib/analytics";

/**
 * Site layout: shared Navbar + Footer + Floating WhatsApp.
 * Resets scroll on route change.
 */
export default function Layout() {
  const { pathname } = useLocation();
  useGoogleAnalytics();

  React.useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="min-h-screen bg-white text-[#0A192F] font-body flex flex-col">
      <Navbar />
      <main className="flex-1 pt-[120px] lg:pt-[152px]">
        <Outlet />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}
